import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'foundation-sites';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ui-dist/jquery-ui';

/* Spindogs basline accordion */
import './modules/accordion';